import { history } from 'app/redux/store';
import { swal_role_denied } from 'app/utils/appHelpers';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import config from '../../config';

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (window.__kurulRoleDenied) {
        return new Promise(() => {});
    }
    const status = error.response?.status;
    if (status === 403) {
        console.log(" ****** ana hata yakalamayaya girdi 403");
        const serverMessage = error.response?.data?.message;
        const roleDenied = serverMessage === "Rolünüz bulunmamaktadır.";

        localStorage.removeItem("token");
        localStorage.removeItem("user");

        if (roleDenied) {
            swal_role_denied();
            // İstek çözülmez. Sahte cevap birim listesine yazılınca sayfa çöküp uyarıyı kapatıyordu.
            return new Promise(() => {});
        }

        NotificationManager.error('Oturmun süresi doldu yeniden giriş yapmanız gerekiyor.');
        window.location.href = config.mainPageUrl + `?status=false&message=${encodeURIComponent("Oturmunuzun süresi dolmuştur. Yeniden giriş yapınız.")}&code=403`;
    }
    else if (status === 401) {
        console.log(" ****** ana hata yakalamayaya girdi 401");
        NotificationManager.error('Yetkisiz erişim')
        return { status: false, data: null, messages: "Yetkisiz erişim" }
    }
    else if (status != null && status !== 400) {
        history.push("/404");
    }

    return Promise.reject(error);
});




export const postUserOtherAuthCheck = async (data) => {
    const configAxios = {
        headers: { Authorization: "Bearer " + data.token }
    }

    const url = `${config.userCheckApiUrl}`;
    return await axios.post(url, data, configAxios)
        .then(response => response.data);
}


export const postCreateUserApi = async (user) => {
    const token = localStorage.getItem("token");
    const configAxios = {
        headers: { Authorization: "Bearer " + token }
    }
    const url = `${config.userCheckApiUrl}/v1/auth/signUp`;
    return await axios.post(url, user, configAxios)
        .then(response => response.data)
}


export const postLoginUserApi = async ({ email, password, recaptchaToken }) => {
    const url = `${config.userAuthApiUrl}/v1/auth/login`;
    try {
        const response = await axios.post(url, { email, password, recaptchaToken });
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            return error.response.data;
        }
        throw error;
    }
}
